import { Document, Page, Text, View, Image, Font, Link, Svg, G, Path } from '@react-pdf/renderer';

import {locationIcon, prizesIcon, processIcon, upgradesIcon, utilizationIcon, valueIcon, worldIcon, chartIcon, co2Icon, currencyIcon, documentIcon, operationIcon, playIcon, cellIcon, logoIcon} from './pdfIcons'
import { faTree } from '@fortawesome/free-solid-svg-icons'

import fontRegular from '../assets/fonts/GT-Eesti-Pro-Text-Regular.ttf';
import fontLight from '../assets/fonts/GT-Eesti-Pro-Text-Light.ttf';
import fontArialRegular from '../assets/fonts/ARIALUNI.TTF';

import mainImg from '../assets/images/pdf-main-image.png'
import infoImg from '../assets/images/info_icon.png'
import orgTank from '../assets/images/original-icon.png'
import rplTank from '../assets/images/replacement-icon.png'
import awardImg from '../assets/images/award.png'

Font.register({ family: 'GT-Eesti',fonts:[
  {src: fontLight, fontWeight:'normal'},
  {src: fontRegular, fontWeight:'bold'},
]});
Font.register({ family: 'arial',fonts:[
  {src: fontArialRegular, fontWeight:'normal'},
]});

const mainTitle={fontSize:'28', paddingBottom:'20px', fontWeight:'bold'};
const subTitle={fontSize:'12', fontWeight:'normal', textTransform:'uppercase', padding:'15px 0 8px'};
const inputTitle={fontSize:'10px', fontWeight:'bold'};
const inputValue={fontFamily:'arial', fontSize:'8'};
const referenceText={fontFamily:'GT-Eesti', fontSize:'10'};
const awardText={fontFamily:'GT-Eesti', fontSize:'12'};
const greenValue={fontFamily:'GT-Eesti', fontSize:'20', fontWeight:'bold'}
const greenLabel={fontFamily:'GT-Eesti', fontSize:'6', fontWeight:'normal', textTransform:'uppercase'}
const moreLink={fontFamily:'GT-Eesti', fontSize:'10', fontWeight:'bold', textDecoration:'none'}
const infoLinks={fontFamily:'GT-Eesti', fontSize:'12', fontWeight:'normal', textTransform:'uppercase', color:'#000000', textDecoration:'none'}
const paddingValue={padding:'0'}
const paddingInLeftCell={paddingRight:'10px'}
const paddingInRightCell={paddingLeft:'10px'}

const yellow = '#DEEC29'
const red = '#EB2814'

Font.registerHyphenationCallback( word => [word]);

const CreatePdf = (props) => {
  const {data} = props

  return  (
    <Document title="Froth Management solution value calculation" author="Metso" language="en">
      <Page size={'A4'} orientation="portrait" style={{padding:'20px 40px', fontFamily:'GT-Eesti'}}>
        <View style={{display:'flex', flexDirection:'column'}}>

          <View style={{display:'flex', flexDirection:'row', paddingBottom:'20px'}}>
            <View style={{flexBasis:'60%',paddingRight:'20px'}}>
              <Text style={mainTitle} >Value & sustainability calculation for Froth Management solution</Text>
              <Text style={{fontSize:'12px'}}>
                The Metso froth management can deliver substantial recovery improvements and support concentrator sustainability target. With froth management upgrade
                Metso improves the froth zone recover by optimize cell crowding and reduced froth transport distance.
              </Text>
            </View>
            <View style={{flexBasis:'40%'}}>
              <Image src={mainImg} style={{height:'180px', objectFit:'contain'}}/>
            </View>
          </View>

          <View style={{display:'flex', flexDirection:'row',...paddingValue}}>
            <View style={{flexBasis:'50%',...paddingInLeftCell}}>
              <SectionInformation icon={locationIcon(30,30,'#ffffff')} label="Country" values={[data.location]} />
              <SectionInformation icon={operationIcon(30,30,'#ffffff')} label="Operation" values={[data.cellSize, data.cellsInCircuit, data.blowerPowerBefore]} />
              <SectionInformation icon={prizesIcon(30,30,'#ffffff')} label="Prizes and costs" values={[data.materialPrize, data.treatmentCharges, data.energyCost]} />
            </View>
            <View style={{flexBasis:'50%',...paddingInRightCell}}>
              <SectionInformation icon={processIcon(30,30,'#ffffff')} label="Process specification" values={[data.material, data.headGrade, data.throughput, data.recovery]} />
              <SectionInformation icon={utilizationIcon(30,30,'#ffffff')} label="Utilization" values={[data.opTime, data.availabilityPercent]} />
              <SectionInformation icon={valueIcon(30,30,'#ffffff')} label="Value proposition" values={[data.expectedShift, data.blowerPowerSaved]} />
            </View>
          </View>

          <Text style={subTitle}>Froth management solution</Text>
          <View style={{display:'flex', flexDirection:'row',...paddingValue}} >
            <View style={{flexBasis:'50%',...paddingInLeftCell}}>
              <GreenBoxInformation icon={upgradesIcon(45,45,'#ffffff')} height="90px" value={[data.proposedNumCellsTotal.value+' x',data.expectedShift.value+'%']} label={["Center launder upgrades","Expected Shift Recovery"]} />
              {/* <GreenBoxInformation icon={upgradesIcon(45,45,'#ffffff')} value={data.proposedNumCellsTotal.value+' x'} label="Center launder upgrades" /> */}
            </View>
            <View style={{flexBasis:'50%',display:'flex', flexDirection:'column', alignItems:'center',justifyContent:'center',...paddingInRightCell}}>
              <Text style={{...inputTitle, paddingBottom:'5px', textAlign:'center', fontSize:'8'}}>Upgraded existing cells with Metso froth management</Text>
              <FrothCells replacedCellsInRow={data.proposedNumCellsInLine.value} cellRows={data.linesParallel.value} cellsInRow={data.cellsPerLine.value} />
              <Text style={{...inputTitle, paddingTop:'5px', fontSize:'8'}}>Green cells upgraded</Text>
            </View>
          </View>

          <Text style={subTitle}>Economical and Environmental benefits</Text>
          <View style={{display:'flex', flexDirection:'row',...paddingValue}}>
            <View style={{flexBasis:'50%',...paddingInLeftCell}}>
              <GreenBoxInformation icon={currencyIcon(45,45,'#ffffff')} value={roundUpTheNumber(data.cashIncrease.value,0)} label={data.cashIncrease.unit} />
            </View>
            <View style={{flexBasis:'50%',...paddingInRightCell}}>
              <GreenBoxInformation icon={co2Icon(45,45,'#ffffff')} value={'-'+roundUpTheNumber(data.co2TotalSavedAnnual.value,0)} label={data.co2TotalSavedAnnual.unit}/>
            </View>
          </View>

          <View style={{display:'flex', flexDirection:'column', paddingTop:'20px'}}>
            <View style={{display:'flex', flexDirection:'row'}}>
              <Text style={{...inputTitle, paddingBottom:'10px'}}>{roundUpTheNumber(data.co2TotalSavedAnnual.value,0)} tons of CO</Text><Text style={{...inputTitle, fontFamily:'arial'}}>{String.fromCharCode(8322)}</Text><Text style={{...inputTitle}}>e reduction equals to</Text>
            </View>
            <View style={{display:'flex', flexDirection:'row' }}>
              <View style={{flexBasis: calculateTreeIconSpace( data.trees) +'%'}}>
                <TreeIcons value={data.trees} />
              </View>
              <View style={{flexBasis: (100 - calculateTreeIconSpace(data.trees) ) +'%'}}>
                <Text style={{...greenValue}}>{Math.round(data.trees)}</Text>
                <Text style={{...greenLabel}}>Planted trees</Text>
              </View>

            </View>
          </View>

        </View>
        <View style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', width:'100%', position:'absolute',left:'40px',bottom:'15px', padding:'0', margin:'0'}} >
          <Text style={{...inputTitle, }}>metso.com</Text>
          <View style={{}}>
            {logoIcon(74,'#000000')}
          </View>
        </View>
      </Page>
      {/* EB2814 */}
      <Page size={'A4'} orientation="portrait" style={{padding:'20px 40px', fontFamily:'GT-Eesti'}}>
        <View style={{display:'flex', flexDirection:'column'}}>

          <Text style={subTitle}>Customer references</Text>

          <View style={{display:'flex', flexDirection:'column', paddingBottom:'10px'}}>
            <View style={{display:'flex', flexDirection:'row', backgroundColor:'#00e2b2' }}>
              <View style={{flexBasis:'40%', display:'flex', flexDirection:'column', backgroundColor:'#000000', height:'70px' }}>
                <Text style={{...referenceText, color:'#ffffff', padding:'8px 8px 4px 8px', fontWeight:'bold'}}>Upgrade optimizes froth area at New Afton</Text>
                <View style={{display:'flex', flexDirection:'row', backgroundColor:'#000000'}}>
                  <View style={{flexBasis:'50%', display:'flex', flexDirection:'column', justifyContent:'space-evenly', padding:'8px'}}>
                    <Text style={{...referenceText, color:'#ffffff'}}>Metal: Co-Au</Text>
                    <Text style={{...referenceText, color:'#ffffff'}}>Country: Canada</Text>
                    <Text style={{...referenceText, color:'#ffffff'}}>Year: 2020/1</Text>
                  </View>
                  <View style={{flexBasis:'50%', alignItems:'flex-end', justifyContent:'flex-end', padding:'8px'}}>
                    <View style={{backgroundColor:yellow, width:'90px', height:'25px', display:'flex', alignItems:'center', justifyContent:'center'}}>                      
                      <Link src='https://www.metso.com/insights/case-studies/mining-and-metals/center-launder-upgrade-optimizes-froth-area-at-new-afton/' style={{...moreLink, color:'#000'}}>Read more here</Link>
                    </View>
                  </View>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>-68%</Text>
                  <Text style={{...greenLabel}}>Froth surfce area</Text>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>-83%</Text>
                  <Text style={{...greenLabel}}>Froth transport distance</Text>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>-22%</Text>
                  <Text style={{...greenLabel}}>Reduction in air flow</Text>
                </View>
              </View>
            </View>
          </View>

          <View style={{display:'flex', flexDirection:'column', paddingBottom:'10px'}}>
            <View style={{display:'flex', flexDirection:'row', backgroundColor:'#00e2b2' }}>
              <View style={{flexBasis:'40%', display:'flex', flexDirection:'column', backgroundColor:'#000000', height:'70px' }}>
                <Text style={{...referenceText, color:'#ffffff', padding:'8px 8px 4px 8px', fontWeight:'bold'}}>Recovery improvement at Constancia mine</Text>
                <View style={{display:'flex', flexDirection:'row', backgroundColor:'#000000'}}>
                  <View style={{flexBasis:'50%', display:'flex', flexDirection:'column', justifyContent:'space-evenly', padding:'8px'}}>
                    <Text style={{...referenceText, color:'#ffffff'}}>Metal: Co-Mo</Text>
                    <Text style={{...referenceText, color:'#ffffff'}}>Country: Peru</Text>
                    <Text style={{...referenceText, color:'#ffffff'}}>Year: 2019</Text>
                  </View>
                  <View style={{flexBasis:'50%', alignItems:'flex-end', justifyContent:'flex-end', padding:'8px'}}>
                    <View style={{backgroundColor:yellow, width:'90px', height:'25px', display:'flex', alignItems:'center', justifyContent:'center'}}>                      
                      <Link src='https://www.metso.com/insights/case-studies/mining-and-metals/flotation-center-launder-upgrade-at-constancia-mine/' style={{...moreLink, color:'#000'}}>Read more here</Link>
                    </View>
                  </View>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>+0.70%</Text>
                  <Text style={{...greenLabel}}>Cu recovery</Text>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>+1.40%</Text>
                  <Text style={{...greenLabel}}>Mo recovery</Text>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>6</Text>
                  <Text style={{...greenLabel}}>Month payback</Text>
                </View>
              </View>
            </View>
          </View>

          <View style={{display:'flex', flexDirection:'column'}}>
            <View style={{display:'flex', flexDirection:'row', backgroundColor:'#00e2b2' }}>
              <View style={{flexBasis:'40%', display:'flex', flexDirection:'column', backgroundColor:'#000000', height:'70px' }}>
                <Text style={{...referenceText, color:'#ffffff', padding:'8px 8px 4px 8px', fontWeight:'bold'}}>Increased recovery at Kennecott</Text>
                <View style={{display:'flex', flexDirection:'row', backgroundColor:'#000000'}}>
                  <View style={{flexBasis:'50%', display:'flex', flexDirection:'column', justifyContent:'space-evenly', padding:'8px'}}>
                    <Text style={{...referenceText, color:'#ffffff'}}>Metal: Co-Mo</Text>
                    <Text style={{...referenceText, color:'#ffffff'}}>Country: Utah, USA</Text>
                    <Text style={{...referenceText, color:'#ffffff'}}>Year: 2021</Text>
                  </View>
                  <View style={{flexBasis:'50%', alignItems:'flex-end', justifyContent:'flex-end', padding:'8px'}}>
                    <View style={{backgroundColor:yellow, width:'90px', height:'25px', display:'flex', alignItems:'center', justifyContent:'center'}}>                      
                      <Link src='https://www.metso.com/insights/case-studies/mining-and-metals/recovery-increase-at-kennecott-with-a-center-launder-upgrade/' style={{...moreLink, color:'#000'}}>Read more here</Link>
                    </View>
                  </View>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>+0.74%</Text>
                  <Text style={{...greenLabel}}>Cu recovery</Text>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>+0.82%</Text>
                  <Text style={{...greenLabel}}>Mo recovery</Text>
                </View>
              </View>
              <View style={{flexBasis:'20%', display:'flex', justifyContent:'center', paddingLeft:'10px', borderLeft:'2px solid #ffffff', boxSizing:'border-box'}}>
                <View>
                  <Text style={{...greenValue}}>-71%</Text>
                  <Text style={{...greenLabel}}>Froth transport distance</Text>
                </View>
              </View>
            </View>
          </View>

          <Text style={subTitle}>Froth Management product information</Text>
          <View style={{display:'flex', flexDirection:'column',...paddingValue}}>
            <View style={{display:'flex', flexDirection:'row',}}>
              <View style={{display:'flex', flexDirection:'row',width:'150px', height:'40px', backgroundColor:yellow, alignItems:'center', marginRight:'10px'}}>
                <Link src='https://www.metso.com/portfolio/flotation-center-launder-upgrade/' style={{padding:'0 8px'}}>
                  {worldIcon(30,30,'#000000')}
                </Link>
                <Link src='https://www.metso.com/portfolio/flotation-center-launder-upgrade/' style={{textDecoration:'none'}}>
                  <Text style={{...infoLinks}}>Web page</Text>
                </Link>
              </View>
              <View style={{display:'flex', flexDirection:'row',width:'150px', height:'40px', backgroundColor:yellow, alignItems:'center', marginRight:'10px'}}>
                <Link src='https://www.metso.com/globalassets/services/flotation/leaflet_center-launder-upgrade_en_web.pdf' style={{padding:'0 8px'}}>
                  {documentIcon(30,30,'#000000')}
                </Link>
                <Link src='https://www.metso.com/globalassets/services/flotation/leaflet_center-launder-upgrade_en_web.pdf' style={{textDecoration:'none'}}>
                  <Text style={{...infoLinks}}>BROCHURE</Text>
                </Link>
              </View>
              <View style={{display:'flex', flexDirection:'row',width:'150px', height:'40px', backgroundColor:yellow, alignItems:'center'}}>
                <Link src='https://youtu.be/ke5rOAXp2ck' style={{padding:'0 8px'}}>
                  {playIcon(30,30,'#000000')}
                </Link>
                <Link src='https://youtu.be/ke5rOAXp2ck' style={{textDecoration:'none'}}>
                  <Text style={{...infoLinks}}>Video</Text>
                </Link>
              </View>
            </View>
          </View>
        </View>
        
        <View style={{display:'flex', flexDirection:'row', backgroundColor:'#000000', marginTop:'20px', border:'0'}}>
          <Image src={awardImg} style={{width:'64px', padding:'10px', flexBasis:'22%'}} />
          <View style={{flexBasis:'73%', display:'flex', flexDirection:'column', backgroundColor:'#000000' }}>
            <Text style={{...awardText, color:'#ffffff', padding:'12px 8px 0 8px', fontWeight:'bold', fontSize:'15'}}>Mining Magazine awards 2021 winner</Text>
            <View style={{display:'flex', flexDirection:'row', backgroundColor:'#000000'}}>
              <View style={{flexBasis:'70%', padding:'8px'}} >
                <Text style={{...awardText, color:'#ffffff'}}>
                  Voted winner of the Services and Support category for the center launder upgrade conducted at Hudbay Minerals, Constancia site.
                </Text>
              </View>
              <View style={{flexBasis:'30%', alignItems:'flex-end', justifyContent:'flex-end', padding:'0 8px 8px 8px'}}>
                <View style={{backgroundColor:yellow, width:'90px', height:'25px', display:'flex', alignItems:'center', justifyContent:'center'}}>                      
                  <Link src='https://www.metso.com/corporate/media/news/2022/1/metso-outotec-voted-winner-of-2021-mining-magazine-service-and-support-award-for-the-center-launder-upgrade-at-hudbay-minerals-constancia-site/' style={{...moreLink, color:'#000'}}>Read more here</Link>
                </View>
              </View>
            </View>
          </View>
          <View style={{flexBasis:'5%', alignItems:'flex-end', justifyContent:'flex-end', position:'absolute', right:'-1', bottom:'-1'}} >
            <Svg width={30} height={30} viewBox='0 0 30 30'>
              <G>
                <Path d='M0,32 L32,0 L32,32Z' fill='#ffffff' stroke='none'/>
              </G>
            </Svg>
          </View>
        </View>

        <Text style={subTitle}>Summary</Text>
        <View style={{width:'100%', display:'flex', flexDirection:'column'}}>
          <View style={{width:'100%', height:'20px', display:'flex', flexDirection:'row',  backgroundColor:'#000000'}}>
            <View style={{flexBasis:'70%'}}>
              <Text style={{...inputTitle, color:'#ffffff'}}> </Text>
            </View>
            <View style={{flexBasis:'30%', display:'flex', alignItems:'center', justifyContent:'center'}}>
              <Text style={{...inputTitle, color:'#ffffff'}}>Upgrade</Text>
            </View>
          </View>
          <Results items={[
            data.newRecoveryPerY,
            data.extraTonnesAnnual,
            data.powerTotalSavedAnnual,
            data.co2TotalSavedAnnual,
            data.co2FootPrint,
            data.co2Payback,
            'Blower',
            data.blowerPowerSavedAnnual,
            data.blowerCO2SavedAnnual,
            'Extra recovery',
            data.powerSavedAnnualMwh,
            data.co2SavedAnnual
          ]} />
        </View>

        <View style={{display:'flex', flexDirection:'row', width:'100%', position:'absolute',left:'40px',bottom:'15px', padding:'0', margin:'0'}} >
          <Image src={infoImg} style={{height:'12px', paddingRight:'5px'}} />
          <Text style={{...inputValue, }}>
            All values and figures seen in the below value calculator are intended for information purposes only and cannot be taken as a guarantee or binding to Metso in any way.
            Currency and market fluctuations will not be updated in real time; economic gain and environmental benefits are only to be seen as indicative to our clientele.
          </Text>
        </View>

      </Page>
    </Document>
  ) 
  
}

const roundUpTheNumber = (value, digits) => {
  return ( Math.round( (value * Math.pow(10,digits)) ) / Math.pow(10,digits) ).toFixed(digits).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

const calculateTreeIconSpace = (num) => {
  if(num > 10000) {
    return (Math.round(num)/1000 < 80 ?Math.round(num)/1000 :85 )
  } else {
    return (Math.round(num)/100 < 80 ?Math.round(num)/100 :85 )
  }
  
}

const SectionInformation = ({icon, label, values}) =>{

  var valueString = ''

  for(var i=0;i<values.length; i++) {
    valueString += values[i].label + ': '

    if(values[i].precision !== undefined) valueString+= roundUpTheNumber(values[i].value,values[i].precision) 
    else valueString+= values[i].value

    if(values[i].unit) valueString+= ' '+values[i].unit

    if(i < values.length -1) valueString+=', '

  }

  return (
    <View style={{display:'flex', flexDirection:'row', marginBottom:'10px'}}>
      <View style={{flexBasis:'23%'}}>
        <View style={{height:'50px', width:'50px', backgroundColor:'#000000', alignItems:'center', justifyContent:'center'}}>
          {icon}
        </View>
      </View>
      <View style={{marginLeft:'20px', display:'flex', flexDirection:'column', flexBasis:'77%'}}>
        <Text style={{...inputTitle}}>{label}</Text>
        <Text style={{...inputValue}}>{valueString}</Text>
      </View>
    </View>
  )
}

const GreenBoxInformation = ({icon, value, label, height='70px'}) =>{

  return (
    <View style={{display:'flex', flexDirection:'row'}}>
      <View style={{height, width:'70px', backgroundColor:'#000000', alignItems:'center', justifyContent:'center', flexBasis:'28%'}}>
        {icon}
      </View>
      <View style={{paddingLeft:'20px', display:'flex', flexDirection:'column', flexBasis:'72%', backgroundColor:'#00e2b2', justifyContent:'center'}}>
        { Array.isArray(value)
          ? value.map((item,index)=> {
            return (
              <View key={index} style={{margin:'5px 0'}}>
                <Text style={{...greenValue}}>{item}</Text>
                <Text style={{...greenLabel}}>{label[index]}</Text>
              </View>
            )
          })

          :(
            <View>
              <Text style={{...greenValue}}>{value}</Text>
              <Text style={{...greenLabel}}>{label}</Text>
            </View>
          )
        }
      </View>
    </View>
  )
}

const InputValueLine = ({title='', value='', unit='', digits=2 }) => {
  return (
    <View style={{display:'flex',flexDirection:'row'}}>
      <Text style={{...inputValue, flexBasis:'50%'}}>{title}</Text>
      <Text style={{...inputValue, flexBasis:'30%', textAlign:'right'}}>{digits === null ?value :roundUpTheNumber(value,digits)}</Text>
      <Text style={{...inputValue, flexBasis:'20%', paddingLeft:'3px'}}>{unit}</Text>
    </View>
  )
}

const FrothCells = ({cellsInRow, cellRows, replacedCellsInRow = 0 }) => {
  const oneRow = []
  const cellheight = cellRows>3 ?(70/cellRows)+'px' : '20px'
  for(var i=0;i<(cellsInRow-replacedCellsInRow);i++) {
    oneRow.push(<Image src={orgTank} style={{marginTop:(Math.floor(i/2)*3)+'px', marginRight:'3px', height:cellheight}}  key={i} />)
  }
  for(var i=0;i<replacedCellsInRow;i++) {
    oneRow.push(<Image src={rplTank} style={{marginTop:(Math.floor((i+(cellsInRow-replacedCellsInRow))/2)*3)+'px', marginRight:'3px', height:cellheight}} key={i+(cellsInRow-replacedCellsInRow)}/>)
  }

  const retVal = []
  for(var i=0;i<cellRows;i++) {
    retVal.push(<View key={i} style={{display:'flex', flexDirection:'row', marginTop:(i ?-(Math.round(cellsInRow/2)-1)*3 +2 +'px' :'0px')}} >{oneRow}</View>)
  }

  return (<View style={{display:'flex', flexDirection:'column'}}>{retVal}</View>)

}

const TreeIcons = ({value}) => {
  var retVal = []
  const divider = value>10000 ?1000 :100
  for(var i=0;i<Math.round(value/divider);i++) {
    retVal.push(
      <View key={i} style={{marginRight:'3px'}}>
        <Svg width={10} viewBox={'0 0 '+faTree.icon[0]+' '+faTree.icon[1]}>
          <Path d={faTree.icon[4]} fill='#51d645'/>
        </Svg>
      </View>
    )
  }

  return (
    <View style={{display:'flex', flexDirection:'column'}}>
      <View style={{display:'flex', flexDirection:'row', paddingBottom:'5px', flexWrap:'wrap'}}>
        {retVal}
      </View>
      <Text style={{...inputValue}}>x {divider}</Text>
    </View>
  )

}

const Results = ({items = []}) =>{
  if(items.length<1) return ''

  var retVal = []

  for(var i=0; i<items.length; i++) {
    if(typeof items[i] === 'string') {
      retVal.push((
        <View style={{width:'100%', height:'20px', display:'flex', flexDirection:'row',  backgroundColor:'#00e2b2', alignItems:'center'}}>
          <Text style={{...inputValue, paddingLeft:'10px'}}>{items[i]}</Text>
        </View>
      ))
    } else {      
      retVal.push((
        <View key={i} style={{display:'flex', flexDirection:'row', backgroundColor:( i%2 ?'#f8f8f8' :'#e6e6e6'), height:'20px', alignItems:'center'}}>
          <Text style={{...inputValue,flexBasis:'60%', paddingLeft:'10px'}}>{items[i].label}</Text>
          <Text style={{...inputValue,flexBasis:'25%', textAlign:'right'}}>{items[i].value ?roundUpTheNumber(items[i].value,items[i].precision) :'-'}</Text>
          <Text style={{...inputValue,flexBasis:'15%', paddingLeft:'3px'}}>{items[i].unit}</Text>
        </View>
      ))
    }
  }

  return (
    <View>
      {retVal}
    </View>
  )

}

export default CreatePdf